import { useCallback, useEffect, useState } from "react";

import { arraysAreEqual } from "@/utils/arrayUtils";

type USBDeviceFilter = {
  vendorId?: number;
  productId?: number;
};

export const useUSBDevices = (filters?: USBDeviceFilter[]) => {
  const [devices, setDevices] = useState<USBDevice[]>([]);

  const refreshDevices = useCallback(async () => {
    if (!navigator.usb) {
      return;
    }
    const newDevices = await navigator.usb.getDevices();
    setDevices(devices => {
      const filteredDevices = filters
        ? newDevices.filter(device => {
            return filters.some(filter => {
              return (
                (!filter.vendorId || device.vendorId === filter.vendorId) &&
                (!filter.productId || device.productId === filter.productId)
              );
            });
          })
        : newDevices;
      return arraysAreEqual(filteredDevices, devices) ? devices : filteredDevices;
    });
  }, [filters]);

  useEffect(() => {
    const interval = setInterval(refreshDevices, 1000);
    return () => clearInterval(interval);
  }, [refreshDevices]);

  return devices;
};
